import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import Tabs from '../Tabs';
import Kpis from '../metrics/Kpis';
import DeviceDataByDay from './DeviceDataByDay';
import { useGetPublisherQuery } from '../../api/publisherApiSlice';
import AppTable from './AppTable';
import DeviceByOs from '../publisher/metrics/DeviceByOs';
import GeolocatedDeviceByOs from '../publisher/metrics/GeolocatedDeviceByOs';
import LocationOptInByOs from '../publisher/metrics/LocationOptInByOs';
import PublisherConsentPie from '../publisher/metrics/PublisherConsentPie';
import PublisherVendorConsent from '../publisher/metrics/PublisherVendorConsent';
import VendorConsentByOs from '../publisher/metrics/VendorConsentByOs';
import ConsentBarChart from '../publisher/metrics/ConsentBarChart';
import LazyLoad from '../LazyLoad';

const DevicesTab = ( { publisherId, startDate, endDate } ) => {
  return (
    <>
      <DeviceDataByDay publisherId={publisherId} startDate={startDate} endDate={endDate} />
      <Row>
        <Col>
          <DeviceByOs publisherId={publisherId} startDate={startDate} endDate={endDate} />
        </Col>
        <Col>
          <GeolocatedDeviceByOs publisherId={publisherId} startDate={startDate} endDate={endDate} />
        </Col>
        <Col>
          <LocationOptInByOs publisherId={publisherId} startDate={startDate} endDate={endDate} />
        </Col>
      </Row>
    </>
  )
}

const ConsentTab = ( { publisherId, startDate, endDate } ) => {
	const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col>
          <PublisherVendorConsent publisherId={publisherId} startDate={startDate} endDate={endDate}/>
        </Col>
        <Col>
          <PublisherConsentPie source={"active_devices"} title={t("publisher.consentAllDevices")} publisherId={publisherId} startDate={startDate} endDate={endDate}/>
        </Col>
        <Col>
          <PublisherConsentPie source={"location_authorized_devices"} title={t("publisher.location_authorized_devices")} publisherId={publisherId} startDate={startDate} endDate={endDate}/>
        </Col>
      </Row>
      <Row>
        <Col>
          <VendorConsentByOs publisherId={publisherId} startDate={startDate} endDate={endDate}/>
        </Col>
        <Col>
          <ConsentBarChart source={"active_devices"} title={t("publisher.optInPerOs")} publisherId={publisherId} startDate={startDate} endDate={endDate}/>
        </Col>
        <Col>
          <ConsentBarChart source={"location_authorized_devices"} title={t("publisher.optInLocalisationPerOs")} publisherId={publisherId} startDate={startDate} endDate={endDate}/>
        </Col>
      </Row>
    </>
  )
}

const AppTab = ({publisherId, startDate, endDate}) => {
  return (
    <AppTable publisherId={publisherId} startDate={startDate} endDate={endDate} />
  )
}

export const PublisherDashboardContainer = ({publisherId, startDate, endDate}) => {
  const { data: kpis, isSuccess } = useGetPublisherQuery({publisherId, startDate, endDate});

  return <>
    <Kpis data={kpis} isSuccess={isSuccess}/>
    <Tabs active={"devices"}>
      <LazyLoad icon="mobile" as={"devices"}>
        <DevicesTab publisherId={publisherId} startDate={startDate} endDate={endDate} />
      </LazyLoad>
      <LazyLoad as="consent" icon="consent">
        <ConsentTab publisherId={publisherId} startDate={startDate} endDate={endDate} />
      </LazyLoad>
      <LazyLoad as="app" icon="app">
        <AppTab publisherId={publisherId} startDate={startDate} endDate={endDate} />
      </LazyLoad>
    </Tabs>
  </>
}
